import  { useEffect } from 'react'
const UseScriptt = url =>{
    useEffect(()=>{
        const canvas = document.getElementById("canvas");
const ctx = canvas.getContext("2d");
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;
let dots = [];
let numDots = 100;
let maxDotSize = 10;

class Dot {
constructor(x, y) {
this.x = x;
this.y = y;
this.dx = (Math.random() - 0.5) * 5;
this.dy = (Math.random() - 0.5) * 5;
this.size = Math.random() * maxDotSize;
}

move() {
this.x += this.dx;
this.y += this.dy;

if (this.x < 0 || this.x > canvas.width) {
    this.dx = -this.dx;
  }
  if (this.y < 0 || this.y > canvas.height) {
    this.dy = -this.dy;
  }
  }
  
  draw() {
  ctx.beginPath();
  ctx.arc(this.x, this.y, this.size, 0, 2 * Math.PI);
  ctx.fill();
  }
  }
  
  for (let i = 0; i < numDots; i++) {
  dots.push(new Dot(Math.random() * canvas.width, Math.random() * canvas.height));
  }
  
  function animate() {
  requestAnimationFrame(animate);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  
  for (let i = 0; i < numDots; i++) {
  let dot1 = dots[i];
  dot1.move();
  dot1.draw();
  for (let j = 0; j < numDots; j++) {
    if (i === j) continue;
    let dot2 = dots[j];
    let dist = calculateDistance(dot1, dot2);
    if (dist < 100) {
      let opacity = 1 - (dist / 100);
      ctx.strokeStyle = `rgba(0, 0, 0, ${opacity})`;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(dot1.x, dot1.y);
      ctx.lineTo(dot2.x, dot2.y);
      ctx.stroke();
    }
  }}
}

function calculateDistance(dot1, dot2) {
let xDist = dot1.x - dot2.x;
let yDist = dot1.y - dot2.y;
return Math.sqrt(xDist * xDist + yDist * yDist);
}

animate();
    },[url])
}
export default UseScriptt